import { StreamLiteGatewayFormValues } from '../types/stream-lite-form';

export const STREAM_LITE_FORM_DEFAULT_VALUES: StreamLiteGatewayFormValues = {
  general: {
    gatewayType: '',
    serialNumber: '',
    macAddress: '',
    imei: '',
    iccid: '',
    deviceName: '',
    expectedPayloadInterval: null,
    localTimeZone: null,
    firmware: '',
  },
  networkConnectivity: {},
  serial: {},
  ioTags: {
    tags: [],
  },
  mqtt: {},
  edgeComputing: {},
};

export const DEVICE_NAME_REQUIRED_MESSAGE = 'Device Name is required';
export const EXPECTED_PAYLOAD_INTERVAL_TYPE_MESSAGE = 'Expected Payload Interval must be a number';
export const EXPECTED_PAYLOAD_INTERVAL_MIN_MESSAGE =
  'Expected Payload Interval must be greater than 0';
